import {
  ADD_CART_ITEM,
  UPDATE_ACI_MODAL,
  UPDATE_CART_ITEMS,
  UPDATE_CART_LOADER,
  UPDATE_EDIT_DATA,
  UPDATE_SELECTED_ITEM,
  UPDATE_VIEW_CART_DATA,
} from "../actionTypes/cartTypes";

export function addCartItem(payload) {
  return { type: ADD_CART_ITEM, payload };
}

export function updateCartItems(payload) {
  return { type: UPDATE_CART_ITEMS, payload };
}

export function updateCartLoader(payload) {
  return { type: UPDATE_CART_LOADER, payload };
}

export function updateViewCartData(payload) {
  return { type: UPDATE_VIEW_CART_DATA, payload };
}

export function updateAciModal(payload) {
  return { type: UPDATE_ACI_MODAL, payload };
}
export function updateEditData(payload) {
  return { type: UPDATE_EDIT_DATA, payload };
}
export function updateSelectedItem(payload) {
  return { type: UPDATE_SELECTED_ITEM, payload };
}
